import { useStaticQuery, graphql } from 'gatsby';

const useEventData = () => {
  const data = useStaticQuery(graphql`
    query {
      singleEvents: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/(src/data/events)/" } }
      ) {
        edges {
          node {
            id
            frontmatter {
              eventId
              slug
              colors {
                primary
                secondary
                tertiary
              }
              status
              name
              date
              description
              startTime
              endTime
              thumb {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
                }
              }
            }
          }
        }
      }
      multiEvents: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/(src/data/multiStageEvents)/" } }
      ) {
        edges {
          node {
            id
            frontmatter {
              multiStageEventId
              slug
              title
              status
              stages {
                eventId
                name
                colors {
                  primary
                  secondary
                  tertiary
                }
                queryParam
                description
                startTime
                endTime
                date
                location
                thumb {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const { singleEvents, multiEvents } = data;

  // Flatten each multi-stage event's stages into the same { node: { frontmatter } } shape as
  // single events, so all consumers can treat both types of event the same way.
  const multiStageEvents = multiEvents.edges.flatMap(({ node }) => {
    const { stages, slug, status, title } = node.frontmatter;

    return stages.map(
      (
        {
          eventId,
          name,
          description,
          colors,
          endTime,
          startTime,
          thumb,
          queryParam,
          date,
          location
        },
        stageIndex
      ) => ({
        node: {
          frontmatter: {
            eventId,
            name,
            slug,
            description,
            colors,
            endTime,
            startTime,
            thumb,
            status,
            queryParam,
            date,
            location,
            // Lets consumers treat the stages as one event, e.g. the navbar dropdown only
            // lists the multi-stage event itself, via its first stage.
            multiStageEventTitle: title,
            stageIndex
          }
        }
      })
    );
  });

  return singleEvents.edges.concat(multiStageEvents);
};

export default useEventData;
